import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import Cropper from "react-easy-crop";
import getCroppedImg from "../components/GetCroppedImage";
import ImgCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Avatar from "react-avatar";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
  Table,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import MainHeader from "../components/MainHeader";
import avatar from "../assets/imgs/new/avatar.png";

import MemoraLogo from "../assets/imgs/memora_logo_small.png";
import AlertLogo from "../assets/imgs/new/paymentSuccess.png";
import {
  getCardDetails,
  getPackages,
  updatePlanEarnings,
  updateProfileImage,
  updateUser,
  updateUserInfo,
} from "../redux/actions/auth.action";
import {
  fetchShipmentDetails,
  getOrderQrCodes,
} from "../redux/actions/orderqrcode.action";
import { loadStripe } from "@stripe/stripe-js";
import { Steps } from "antd";
import { Timeline } from "antd";
import "antd/dist/antd.css";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  Elements,
  ElementsConsumer,
} from "@stripe/react-stripe-js";
import axios from "axios";
import { BASE_DOMAIN } from "../constants";
import moment from "moment";
import QRCode from "qrcode.react";
import { getMemoirs } from "../redux/actions/memoir.action";
import { customAlert } from "../redux/actions/alertActions";
import CustomCard from "../components/CustomCard";
import "react-image-crop/dist/ReactCrop.css";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
} from 'react-image-crop';
let stripePromise = loadStripe(
  `pk_test_51ISi2nFXnKyMHMzeS9JMGVaj46u104MqmtUONfIyvZNILPvZPgooNVFlPO4Wq3aZXCl8RHkTzP1e6k1s1ju89uNr00mbBy6caY`
);
const { Step } = Steps;
function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        width: 90,
      },
      aspect,
      mediaWidth,
      mediaHeight,
    ),
    mediaWidth,
    mediaHeight,
  );
}
class ManageAccount extends Component {
  ref_updatePersonalData = createRef(null);
  state = {
    edit: {
      personalData: false,
      updatePaymentDetail: false,
      modifyMembership: false,
      updatePassword: false,
    },
    personalData: {
      title: "",
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      address: "",
      address1: "",
      address2: "",
      town: "",
      country: "",
      zip_code: "",
      changePassword: false,
      new_password: "",
      repeat_password: "",
    },
    confirm_card: false,
    imageUpdate: false,
    profile_image: [],
    profileImage: false,
    price_id: "",
    plan_amount: "",
    plan_name: "",
    viewOrderModal: false,
    singleOrder: "",
    orderDetails: "",
    modal: false,
    croppedAreaPixels: "",
    crop: undefined,
    imgRef: React.createRef(),
    hiddenAnchorRef: React.createRef(),
    completedCrop: undefined,
    zoom: 1,
    aspect: 16 / 9,
    currentPassword: {
      current_password: "",
    },
  }
  
  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  qrCodesBGColors = ["#DBC3A6", "#FBBB00", "#FF4B55"];

  componentDidMount() {
    this.props.getCardDetails(this.props.authUser.id);
    this.props.getPackages();
    this.props.getQROrders(this.props.authUser.id);
    this.props.fetchShippers();
    if (this.props.memoirs.length == 0) {
      this.props.fetchMemoirs(this.props.authUser.id);
    }
    localStorage.removeItem("QR_Data");
  }
  setEdit = (name) => {
    let { edit } = this.state;
    edit[name] = !this.state.edit[name];
    this.setState({ edit });
  };
  setClear = () => {
    this.setState.personalData = {
      changePassword: "",
      new_password: "",
      repeat_password: "",
    };
    this.setState.currentPassword = {
      current_password: "",
    };
  };
  handlePersonalDataChange = (e) => {
    let { personalData } = this.state;
    personalData[e.target.name] = e.target.value;
    this.setState({ personalData });
  };
  handleCurrentDataChange = (e) => {
    let { currentPassword } = this.state;
    currentPassword[e.target.name] = e.target.value;
    this.setState({ currentPassword });
  };

  viewToggle = () => {
    this.setState({
      viewOrderModal: !this.state.viewOrderModal,
    });
  };
  confirmCardToggle = () => {
    this.setState({
      confirm_card: !this.state.confirm_card,
    });
  };
  getMemoirName = (id) => {
    if (id != undefined) {
      let obj = this.props.memoirs.find((mem) => mem.id == id);
      if (obj) {
        return obj.memoir_title;
      } else {
        return "N/A";
      }
    } else {
      return "N/A";
    }
  };
  getStep = () => {
    if (this.state.singleOrder && this.state.singleOrder.status) {
      switch (this.state.singleOrder.status) {
        case "placed":
          return 0;
          break;
        case "shipped":
          return 1;
          break;
        case "delivered":
          return 2;
          break;
        case "completed":
          return 3;
          break;
      }
    } else {
      return 0;
    }
  };
  clearFormData = (name) => {
    let obj = this.state[name];
    for (let key of Object.keys(obj)) {
      obj[key] = "";
    }
    this.setState({ [name]: obj });
  };
  getShipperName = (id) => {
    if (id) {
      let obj =
        this.props.shippers &&
        this.props.shippers.find((shipper) => shipper.id == id);
      if (obj) {
        return obj.shipment_name;
      } else {
        return "N/A";
      }
    } else {
      return "N/A";
    }
  };
  getRole = (memId, uid) => {
    if (this.props.memoirs.length > 0) {
      let memoirData = this.props.memoirs.find((mem) => mem.id == memId);
      let roleCheck = memoirData.collaborators.find(
        (collab) => collab.id == uid
      );
      if (roleCheck) {
        return roleCheck.role;
      } else {
        return "owner";
      }
    } else {
      return "owner";
    }
  };
  getMemoirDetails = (id) => {
    if (id != undefined) {
      let obj =
        this.props.memoirs.length > 0 &&
        this.props.memoirs.find((memoir) => memoir.id == id);
      if (obj != null) {
        return obj;
      } else {
        return "N/A";
      }
    } else {
      return "N/A";
    }
  };
  onCropChange = (crop) => {
    this.setState({ crop });
  };

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    this.setState({ croppedAreaPixels: croppedAreaPixels });
  };

  onZoomChange = (zoom) => {
    this.setState({ zoom });
  };
  onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0 ) {
      this.setState({ crop: undefined });
      const reader = new FileReader();
      reader.addEventListener('load', () =>
        this.setState({
              profile_image: URL.createObjectURL(
                e.target.files[0]
             ),
            })
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  }
  onImageLoad = (e) => {
    const { aspect } = this.state;
    if (aspect) {
      const { width, height } = e.currentTarget;
      const crop = centerAspectCrop(width, height, aspect);
      this.setState({ crop });
    }
  }

  handleChangeCrop(_, percentCrop) {
    this.setState({ crop: percentCrop });
  }
  handleCompleteCrop(c) {
    this.setState({ completedCrop: c });
  }
  saveImage = async () => {
    try {
      const croppedImage = await getCroppedImg(
        this.state.profile_image,
        this.state.croppedAreaPixels
      );
    
      if (this.state.profile_image) {
        this.setState({
          profile_loading: true,
        });
        this.props.updateProfileImage(
          this.props.authUser.id,
          croppedImage,
          this.props.authUser.profile_image,
          () => {
            this.setState({
              imageUpdate: false,
              profile_image: null,
              profile_loading: false,
            });
          }
        );
      } else {
        this.props.customAlert(true, "Please Select Image");

        setTimeout(() => {
          this.props.customAlert(false, "");
        }, 1500);
        // toast.warning('Please Select Image');
      }
    } catch (e) {
      console.error(e);
    }
  };

  render() {
    console.log("profile_image", this.state.profile_image);
    let { auth, authUser, qr_orders, imageLoading } = this.props;
    const { crop, aspect } = this.state;

    return (
      <>
        <div className="container-fluid pt-3">
          <MainHeader heading={"Manage Account"} />
          <hr className="mb-0" />
          <div className="mt-5">
            <Form
              ref={(ref) => (this.ref_updatePersonalData = ref)}
              onSubmit={async (e) => {
                e.preventDefault();
                if (
                  this.state.currentPassword.current_password &&
                  this.state.personalData.new_password !=
                    this.state.personalData.repeat_password
                ) {
                  this.props.customAlert(true, "Password didn't matched");
                  setTimeout(() => {
                    this.props.customAlert(false, "");
                  }, 1500);

                  // alert("Password didn't matched");
                } else {
                  await this.props.updateUser(
                    authUser.id,
                    this.state.personalData,
                    this.state.currentPassword,
                    () => {
                      this.setEdit("personalData");
                      this.setEdit("updatePassword");
                      this.setEdit("currentPassword");
                    }
                  );
                }
              }}
            >
              <h5 className="font-weight-bold">
                Personal Data
                <span className="ml-2">
                  {!this.state.edit.personalData && (
                    <i
                      className="fa fa-pencil edit-pencil"
                      style={{ cursor: "pointer" }}
                      onClick={async (e) => {
                        await this.setState({
                          personalData: JSON.parse(JSON.stringify(authUser)),
                        });
                        await this.setEdit("personalData");
                      }}
                    ></i>
                  )}
                </span>
              </h5>
              <p className="m-0 f-14">Your personal information</p>
              <Row className="f-14 mt-3">
                <Col xs="3">
                  <p className="m-0 font-weight-bold">Title:</p>
                </Col>
                <Col md="6" xs="9">
                  {this.state.edit.personalData ? (
                    <Input
                      className="custom-form-control white"
                      type="select"
                      name="title"
                      value={this.state.personalData.title}
                      required
                      onChange={(e) => this.handlePersonalDataChange(e)}
                    >
                      <option
                        className="custom-form-control white"
                        selected=""
                        value=""
                      >
                        Title
                      </option>
                      <option value="Mr">Mr</option>
                      <option value="Mrs">Mrs</option>
                      <option value="Ms">Ms</option>
                      <option value="Dr">Dr</option>
                    </Input>
                  ) : (
                    <p className="m-0">{authUser.title}</p>
                  )}
                </Col>
              </Row>
              <Row className="f-14 mt-3">
                <Col xs="3">
                  <p className="m-0 font-weight-bold">First Name:</p>
                </Col>
                <Col md="6" xs="9">
                  {this.state.edit.personalData ? (
                    <Input
                      required
                      type="text"
                      name="first_name"
                      value={this.state.personalData.first_name}
                      onChange={(e) => this.handlePersonalDataChange(e)}
                    />
                  ) : (
                    <p className="m-0">{authUser.first_name}</p>
                  )}
                </Col>
              </Row>
              <Row className="f-14 mt-3">
                <Col xs="3">
                  <p className="m-0 font-weight-bold">Last Name:</p>
                </Col>
                <Col md="6" xs="9">
                  {this.state.edit.personalData ? (
                    <Input
                      required
                      type="text"
                      name="last_name"
                      value={this.state.personalData.last_name}
                      onChange={(e) => this.handlePersonalDataChange(e)}
                    />
                  ) : (
                    <p className="m-0">{authUser.last_name}</p>
                  )}
                </Col>
              </Row>
              <Row className="f-14 mt-3">
                <Col xs="3">
                  <p className="m-0 font-weight-bold">Mobile Number:</p>
                </Col>
                <Col md="6" xs="9">
                  {this.state.edit.personalData ? (
                    <Input
                      required
                      type="text"
                      disabled
                      name="phone"
                      readOnly
                      value={this.state.personalData.phone}
                      onChange={(e) => this.handlePersonalDataChange(e)}
                    />
                  ) : (
                    <p className="m-0">{authUser.phone}</p>
                  )}
                </Col>
              </Row>
              <Row className="f-14 mt-3">
                <Col xs="3">
                  <p className="m-0 font-weight-bold">Email:</p>
                </Col>
                <Col md="6" xs="9">
                  {this.state.edit.personalData ? (
                    <Input
                      required
                      type="email"
                      name="email"
                      readOnly
                      disabled
                      value={this.state.personalData.email}
                      onChange={(e) => this.handlePersonalDataChange(e)}
                    />
                  ) : (
                    <p className="m-0">{authUser.email}</p>
                  )}
                </Col>
              </Row>
              <Row className="f-14 mt-3">
                <Col xs="3">
                  <p className="m-0 font-weight-bold">Address:</p>
                </Col>
                <Col md="6" xs="9">
                  {this.state.edit.personalData ? (
                    <Input
                      required
                      type="textarea"
                      name="address"
                      value={this.state.personalData.address}
                      onChange={(e) => this.handlePersonalDataChange(e)}
                    />
                  ) : (
                    <p className="m-0">{authUser.address ?? "N/A"}</p>
                  )}
                </Col>
              </Row>
              <Row className="f-14 mt-3">
                <Col xs="3">
                  <p className="m-0 font-weight-bold">Address line 1:</p>
                </Col>
                <Col md="6" xs="9">
                  {this.state.edit.personalData ? (
                    <Input
                      required
                      type="textarea"
                      name="address1"
                      value={this.state.personalData.address1}
                      onChange={(e) => this.handlePersonalDataChange(e)}
                    />
                  ) : (
                    <p className="m-0">{authUser.address1 ?? "N/A"}</p>
                  )}
                </Col>
              </Row>
              <Row className="f-14 mt-3">
                <Col xs="3">
                  <p className="m-0 font-weight-bold">Address line 2:</p>
                </Col>
                <Col md="6" xs="9">
                  {this.state.edit.personalData ? (
                    <Input
                      required
                      type="textarea"
                      name="address2"
                      value={this.state.personalData.address2}
                      onChange={(e) => this.handlePersonalDataChange(e)}
                    />
                  ) : (
                    <p className="m-0">{authUser.address2 ?? "N/A"}</p>
                  )}
                </Col>
              </Row>
              <Row className="f-14 mt-3">
                <Col xs="3">
                  <p className="m-0 font-weight-bold">Town:</p>
                </Col>
                <Col md="6" xs="9">
                  {this.state.edit.personalData ? (
                    <Input
                      required
                      type="textarea"
                      name="town"
                      value={this.state.personalData.town}
                      onChange={(e) => this.handlePersonalDataChange(e)}
                    />
                  ) : (
                    <p className="m-0">{authUser.town ?? "N/A"}</p>
                  )}
                </Col>
              </Row>
              <Row className="f-14 mt-3">
                <Col xs="3">
                  <p className="m-0 font-weight-bold">Zip code:</p>
                </Col>
                <Col md="6" xs="9">
                  {this.state.edit.personalData ? (
                    <Input
                      required
                      type="textarea"
                      name="zip_code"
                      value={this.state.personalData.zip_code}
                      onChange={(e) => this.handlePersonalDataChange(e)}
                    />
                  ) : (
                    <p className="m-0">{authUser.zip_code ?? "N/A"}</p>
                  )}
                </Col>
              </Row>
              <Row className="f-14 mt-3">
                <Col xs="3">
                  <p className="m-0 font-weight-bold">Country:</p>
                </Col>
                <Col md="6" xs="9">
                  {this.state.edit.personalData ? (
                    <Input
                      required
                      type="textarea"
                      name="country"
                      value={this.state.personalData.country}
                      onChange={(e) => this.handlePersonalDataChange(e)}
                    />
                  ) : (
                    <p className="m-0">{authUser.country ?? "N/A"}</p>
                  )}
                </Col>
              </Row>

              {this.state.edit.personalData && (
                <FormGroup check className="mt-4">
                  <Input
                    type="checkbox"
                    id="updatePassword"
                    checked={this.state.edit.updatePassword}
                    onChange={(e) => {
                      this.setEdit("updatePassword");
                    }}
                  />{" "}
                  <Label for="updatePassword">Change Password</Label>
                </FormGroup>
              )}
              {this.state.edit.personalData &&
                this.state.currentPassword &&
                this.state.edit.updatePassword && (
                  <>
                    <Row className="f-14">
                      <Col xs="3">
                        <p className="m-0 font-weight-bold">
                          Current Password:
                        </p>
                      </Col>
                      <Col md="6" xs="10">
                        {this.state.currentPassword ? (
                          <Input
                            required
                            type="password"
                            name="current_password"
                            autoComplete="false"
                            value={this.state.currentPassword.current_password}
                            onChange={(e) => this.handleCurrentDataChange(e)}
                          />
                        ) : (
                          <p className="m-0">........</p>
                        )}
                      </Col>
                    </Row>
                    <Row className="f-14 my-3">
                      <Col xs="3">
                        <p className="m-0 font-weight-bold">New Password:</p>
                      </Col>
                      <Col md="6" xs="10">
                        {this.state.edit.personalData ? (
                          <Input
                            required
                            type="password"
                            name="new_password"
                            value={this.state.personalData.new_password}
                            onChange={(e) => this.handlePersonalDataChange(e)}
                          />
                        ) : (
                          <p className="m-0">..........</p>
                        )}
                      </Col>
                    </Row>
                    <Row className="f-14 mt-3">
                      <Col xs="3">
                        <p className="m-0 font-weight-bold">Repeat Password:</p>
                      </Col>
                      <Col md="6" xs="10">
                        {this.state.edit.personalData ? (
                          <Input
                            required
                            type="password"
                            name="repeat_password"
                            value={this.state.personalData.repeat_password}
                            onChange={(e) => this.handlePersonalDataChange(e)}
                          />
                        ) : (
                          <p className="m-0">..........</p>
                        )}
                      </Col>
                    </Row>
                  </>
                )}
              {this.state.edit.personalData && (
                <div className="d-inline-flex mt-3 align-items-center">
                  <Button
                    className="btn-outline dashboard-btn"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => this.setEdit("personalData")}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    className="btn-outline ml-2 dashboard-btn"
                    style={{ cursor: "pointer" }}
                  >
                    Update
                  </Button>
                </div>
              )}
            </Form>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                if (this.state.profile_image) {
                  this.props
                    .updateProfileImage(
                      authUser.id,
                      this.state.profile_image,
                      authUser.profile_image
                    )
                    .then((res) => {
                      this.setState({
                        imageUpdate: false,
                      });
                    });
                } else {
                  this.props.customAlert(true, "Please Select Image");
                }
              }}
            >
              <Row className="f-14 mt-3">
                <Col xs="3">
                  <p className="m-0 font-weight-bold">
                    Profile Image
                    <span className="ml-2">
                      {!this.state.imageUpdate ? (
                        <i
                          className="fa fa-pencil edit-pencil"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={async (e) => {
                            await this.setState({
                              imageUpdate: true,
                            });
                          }}
                        ></i>
                      ) : (
                        <div className="d-inline-flex align-items-center">
                          <button
                            type="submit"
                            className="fa fa-save text__primary border-0 bg-transparent"
                            style={{
                              cursor: "pointer",
                            }}
                          ></button>
                          <i
                            className="fa fa-times ml-3"
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              this.setState({
                                imageUpdate: false,
                                profile_image: null,
                              });
                            }}
                          ></i>
                        </div>
                      )}
                    </span>
                  </p>
                </Col>
                <Col xs="9">
                  {this.state.imageUpdate ? (
                    imageLoading ? (
                      <Spinner size="sm" />
                    ) : (
                      <>
                        <input
                          type="file"
                          required
                          // onChange={(e) =>
                          //   this.setState({
                          //     profile_image: URL.createObjectURL(
                          //       e.target.files[0]
                          //     ),
                          //   })
                          // }
                          onChange={this.onSelectFile}
                        />
                        {/* <br />
                        <label>
                          {" "}
                          Max <span className="text-danger">1MB</span>
                        </label> */}
                      </>
                    )
                  ) : (
                    // <div className="d-flex align-items-center">
                    //   <span className="avatar-topbar">
                    //     <img src={avatar} />
                    //   </span>
                    // </div>
                    <Avatar
                      round={true}
                      className="memoir_no_display_img"
                      src={
                        authUser.profile_image
                          ? authUser.profile_image
                          : MemoraLogo
                      }
                      size={48}
                    />
                  )}
                </Col>
              </Row>
            </Form>
            <hr className="my-5 custom-hr" />
            <Elements stripe={stripePromise}>
              <ElementsConsumer>
                {({ elements, stripe }) => (
                  <form
                    onSubmit={async (e) => {
                      e.preventDefault();
                      this.setState({ loading: true });
                      const cardElement = await elements.getElement(
                        CardNumberElement
                      );
                      const cardElement2 = await elements.getElement(
                        CardExpiryElement
                      );
                      const cardElement3 = await elements.getElement(
                        CardCvcElement
                      );

                      const { error, paymentMethod } =
                        await stripe.createPaymentMethod({
                          type: "card",
                          card: cardElement,
                          billing_details: {
                            email: authUser.email,
                            name:
                              authUser.first_name + " " + authUser.last_name,
                          },
                        });

                      if (error) {
                        this.props.customAlert(true, "Card details not added");
                        setTimeout(() => {
                          this.props.customAlert(false, "");
                        }, 1500);
                        // alert(
                        // 	'Card details not added',
                        // 	'danger'
                        // );
                        this.setState({
                          loading: false,
                        });
                      } else {
                        console.log("[PaymentMethod]", paymentMethod);
                        const result = await stripe.createToken(cardElement);
                        console.log(result);
                        if (result.error) {
                          this.props.customAlert(true, result.error.message);
                          setTimeout(() => {
                            this.props.customAlert(false, "");
                          }, 1500);
                          // alert(
                          // 	result.error.message,
                          // 	'danger'
                          // );
                          this.setState({
                            loading: false,
                          });
                          console.log(result);
                          return;
                        } else {
                          if (authUser.customer_id) {
                            let obj = {
                              customer: authUser.customer_id,
                              token: result.token.id,
                            };
                            await axios
                              .post(`${BASE_DOMAIN}/updateCard`, {
                                ...obj,
                              })
                              .then(async () => {
                                this.props.getCardDetails(
                                  this.props.authUser.id,
                                  (res) => {
                                    this.props.customAlert(
                                      true,

                                      `This card **** **** **** ${res} will be charged`
                                    );
                                    setTimeout(() => {
                                      this.props.customAlert(false, "");
                                    }, 1500);
                                  }
                                );
                                // toast.success(
                                // 	'Payment Details Updated'
                                // );
                                this.setState({
                                  loading: false,
                                });
                                this.setEdit("updatePaymentDetail");
                              });
                            console.log(obj);
                          } else {
                            let obj = {
                              email: authUser.email,
                              token: result.token.id,
                            };
                            axios
                              .post(`${BASE_DOMAIN}/createCustomer`, {
                                ...obj,
                              })
                              .then((res) => {
                                if (res.data.success) {
                                  let obj = {
                                    customer_id: res.data.data.id,
                                  };
                                  this.props.updateUserInfo(authUser.id, obj);
                                  // toast.success(
                                  // 	'Payment Details Updated'
                                  // );
                                  this.props.customAlert(
                                    true,
                                    "Payment Details Updated"
                                  );

                                  setTimeout(() => {
                                    this.props.customAlert(false, "");
                                  }, 1500);
                                  this.setState({
                                    loading: false,
                                  });
                                  this.setEdit("updatePaymentDetail");
                                } else {
                                  this.props.customAlert(
                                    true,
                                    "Payment Details Update Failes"
                                  );
                                  setTimeout(() => {
                                    this.props.customAlert(false, "");
                                  }, 1500);
                                  // toast.error(
                                  // 	'Payment Details Update Failes'
                                  // );
                                  this.setState({
                                    loading: false,
                                  });
                                  this.setEdit("updatePaymentDetail");
                                }
                              });
                          }
                        }
                      }
                    }}
                  >
                    <div className="mt-5">
                      <h5 className="font-weight-bold">
                        {authUser.customer_id
                          ? "Update Payment Details"
                          : "Add Payment Details"}
                        <span className="ml-2">
                          {!this.state.edit.updatePaymentDetail && (
                            <i
                              className="fa fa-pencil edit-pencil"
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={(e) =>
                                this.setEdit("updatePaymentDetail")
                              }
                            ></i>
                          )}
                        </span>
                      </h5>

                      {this.state.edit.updatePaymentDetail ? (
                        <>
                          <div className="row mt-3">
                            <div className="col-lg-4">
                              <div className="form-group">
                                <label className="font-weight-bold">
                                  Card Number
                                </label>
                                <CardNumberElement />{" "}
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="form-group">
                                <label className="font-weight-bold">
                                  MM/YY
                                </label>
                                <CardExpiryElement />
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="form-group">
                                <label className="font-weight-bold">
                                  CVC Code
                                </label>
                                <CardCvcElement />{" "}
                              </div>
                            </div>
                          </div>
                          <small className="mt-4">
                            I authorize Memora Group Ltd to save this payment
                            method and automatically charge this payment method
                            whenever a subscription is associated with it.
                          </small>
                          <br />
                          {this.state.edit.updatePaymentDetail && (
                            <div className="d-inline-flex mt-3 align-items-end">
                              {this.state.loading ? (
                                <Spinner size="sm" />
                              ) : (
                                <>
                                  <Button
                                    className="btn-outline dashboard-btn"
                                    onClick={(e) =>
                                      this.setEdit("updatePaymentDetail")
                                    }
                                  >
                                    Cancel
                                  </Button>
                                  <Button
                                    type="submit"
                                    className="btn-outline ml-3 dashboard-btn"
                                  >
                                    Update
                                  </Button>
                                </>
                              )}
                            </div>
                          )}
                        </>
                      ) : (
                        <Row className="f-14 mt-3">
                          <Col xs="2">
                            <p className="m-0 font-weight-bold">Card Number:</p>
                          </Col>
                          <Col xs="10">
                            <p className="m-0">
                              {this.props.card_details
                                ? this.props.card_details.last4
                                  ? `**** **** **** ${this.props.card_details.last4}`
                                  : "No Card Available"
                                : "No Card Available"}
                            </p>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </form>
                )}
              </ElementsConsumer>
            </Elements>

            <hr className="my-5 custom-hr" />

            <div className="mt-5">
              <h5 className="font-weight-bold">
                Modify Membership
                {!this.state.edit.modifyMembership && (
                  <i
                    className="fa fa-pencil edit-pencil ml-2"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      if (authUser.customer_id) {
                        let obj = auth.prices?.find(
                          (price) => price.id == authUser?.price_id
                        );
                        if (obj) {
                          this.setState({
                            price_id: obj.id,
                          });
                        }
                        this.setEdit("modifyMembership");
                      } else {
                        this.setEdit("updatePaymentDetail")(
                          this.props.customAlert(
                            true,
                            "Please add payment details!"
                          ),
                          setTimeout(() => {
                            this.props.customAlert(false, "");
                          }, 1500)
                        );
                      }
                    }}
                  ></i>
                )}
              </h5>
              <p className="m-0 f-14">Your current membership plan</p>
              {!this.state.edit.modifyMembership ? (
                <Row className="align-items-center mt-3">
                  <Col xs="2">
                    <FormGroup check>
                      <Label check className="">
                        <Input type="radio" name="activeplan" checked></Input>
                        <span className="text-capitalize">
                          {authUser.plan_name} - {authUser.plan_duration}
                        </span>
                      </Label>
                      {authUser.plan_name == "free" ? (
                        <p className="text-danger">
                          You need to add your payment details
                        </p>
                      ) : (
                        ""
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              ) : (
                <>
                  {/* <FormGroup className='mt-4' check>
											<Label
												check
												className='font-weight-bold '
											>
												<Input
													type='radio'
													name='plan'
													value=''
													onChange={e =>
														this.setState({
															price_id:
																e.target.value,
															plan_name: 'free',
														})
													}
												></Input>
												Free Plan
											</Label>
										</FormGroup> */}
                  <h5 className="mt-3 f-18 font-weight-bold">Advance Plan</h5>

                  {auth.prices &&
                    auth.prices
                      .filter((price) => price.nickname == "Advance")
                      .sort((a, b) => a.unit_amount - b.unit_amount)
                      .map((price) => (
                        <Row className="align-items-center mt-3">
                          <Col xs="2">
                            <FormGroup check>
                              <Label check className="">
                                {/* {console.log('first',price.id == this.state.price_id)} */}
                                <Input
                                  checked={price.id == this.state.price_id}
                                  type="radio"
                                  name="plan"
                                  value={price.id}
                                  onChange={(e) =>
                                    this.setState({
                                      price_id: e.target.value,
                                      plan_amount: price.unit_amount / 100,
                                      plan_name: price.nickname,
                                    })
                                  }
                                ></Input>
                                <span className="text-capitalize">
                                  {price.recurring.interval}
                                  ly
                                </span>
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col>
                            <p className="m-0 font-weight-bold">
                              ${price.unit_amount / 100}
                            </p>
                          </Col>
                        </Row>
                      ))}
                  <h5 className="mt-3 f-18 font-weight-bold">Premium Plan</h5>
                  {auth.prices &&
                    auth.prices
                      .filter((price) => price.nickname == "Premium")
                      .sort((a, b) => a.unit_amount - b.unit_amount)
                      .map((price) => (
                        <Row className="align-items-center mt-3">
                          <Col xs="2">
                            <FormGroup check>
                              <Label check className="">
                                <Input
                                  checked={price.id == this.state.price_id}
                                  type="radio"
                                  name="plan"
                                  value={price.id}
                                  onChange={(e) =>
                                    this.setState({
                                      price_id: e.target.value,
                                      plan_amount: price.unit_amount / 100,
                                      plan_name: price.nickname,
                                    })
                                  }
                                ></Input>
                                <span className="text-capitalize">
                                  {price.recurring.interval}
                                  ly
                                </span>
                              </Label>
                            </FormGroup>
                          </Col>
                          <Col>
                            <p className="m-0 font-weight-bold">
                              ${price.unit_amount / 100}
                            </p>
                          </Col>
                        </Row>
                      ))}
                </>
              )}
            </div>
            {this.state.edit.modifyMembership && (
              <div className="d-inline-flex mt-3 align-items-center">
                <>
                  <Button
                    className="btn-outline dashboard-btn"
                    onClick={(e) => {
                      this.setState({
                        price_id: "",
                        plan_amount: "",
                        plan_name: "",
                      });
                      this.setEdit("modifyMembership");
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => this.confirmCardToggle()}
                    className="btn-outline dashboard-btn ml-2"
                  >
                    Upgrade
                  </Button>
                  <Modal isOpen={this.state.confirm_card} centered>
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        this.setState({
                          loading: true,
                        });
                        let obj = {
                          customer_id: authUser.customer_id,
                          price_id: this.state.price_id,
                        };
                        axios
                          .post(`${BASE_DOMAIN}/changeSubscription`, {
                            ...obj,
                          })
                          .then((res) => {
                            console.log(res);
                            if (res.data.success) {
                              let data = res.data.data;
                              let plan = data.plan;
                              console.log(plan);
                              let nObj = {
                                price_id: plan.id,
                                plan_duration: plan.interval,
                                plan_name: plan.nickname.toLowerCase(),
                              };
                              this.props.updateUser(
                                authUser.id,
                                { ...nObj },
                                "text",
                                () => this.setEdit("modifyMembership")
                              );
                              this.props.customAlert(
                                true,
                                "Modify Membership Updated"
                              );

                              setTimeout(() => {
                                this.props.customAlert(false, "");
                              }, 1500);
                              if (this.state.plan_name != "free") {
                                let newObj = {
                                  plan_amount: this.state.plan_amount,
                                  plan_name: this.state.plan_name,
                                };
                                this.props.updatePlanEarnings(
                                  authUser.id,
                                  newObj
                                );
                              }
                              console.log(res);
                              this.confirmCardToggle();
                              this.setState({
                                loading: false,
                              });
                            } else {
                              this.props.customAlert(
                                true,
                                "Modify Membership Update Failes"
                              );
                              setTimeout(() => {
                                this.props.customAlert(false, "");
                              }, 1500);
                              this.setState({
                                loading: false,
                              });
                              this.setEdit("modifyMembership");
                            }
                          });
                      }}
                    >
                      <ModalBody className="text-center">
                        <img src={AlertLogo} alt="Alert Logo" />
                        <br />
                        <div className="mt-4">
                          <strong>
                            Are you sure you want to proceed with card Ending
                            with {this.props.card_details?.last4}
                          </strong>
                        </div>
                        <div className="d-flex mt-3 justify-content-center">
                          <Button
                            className="btn-outline dashboard-btn"
                            disabled={this.state.loading}
                            onClick={(e) => {
                              this.setState({
                                price_id: "",
                                plan_amount: "",
                                plan_name: "",
                              });
                              this.setEdit("modifyMembership");
                              this.confirmCardToggle();
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            disabled={
                              !this.state.price_id || this.state.loading
                            }
                            className="btn-outline dashboard-btn ml-2"
                          >
                            {this.state.loading ? (
                              <Spinner size="sm" />
                            ) : (
                              "Confirm"
                            )}
                          </Button>
                        </div>
                      </ModalBody>
                    </Form>
                  </Modal>
                </>
              </div>
            )}
            <hr className="my-5 custom-hr" />
            <div className="mt-5">
              <h5 className="font-weight-bold">Order History</h5>
              <p className="m-0 f-14">Your orders</p>
              {qr_orders.length > 0 ? (
                <Table borderless responsive>
                  <thead>
                    <tr className="f-14 text-muted">
                      <th style={{ fontWeight: "normal" }}>Order ID</th>
                      <th style={{ fontWeight: "normal" }}>Order Date</th>
                      {/* <th style={{ fontWeight: "normal" }}>Delivery Date</th> */}
                      <th style={{ fontWeight: "normal" }}>Amount</th>
                      <th style={{ fontWeight: "normal" }}>Status</th>
                      {/* <th style={{ fontWeight: "normal" }}>Description</th> */}
                      <th style={{ fontWeight: "normal" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody className="header">
                    {qr_orders &&
                      qr_orders.map((qr, index) => (
                        <tr key={index}>
                          <td>{qr.id}</td>
                          <td>
                            {moment
                              .unix(qr.created_at.seconds)
                              .format("MM-DD-YYYY")}
                          </td>
                          {/* <td>xyz</td> */}
                          <td>£{qr.total}</td>
                          <td className="text-capitalize">{qr.status}</td>
                          {/* <td>
                            Lorem Ipsum is simply dummy text of the printing
                            <br /> and typesetting industr.
                          </td> */}
                          <td>
                            <i
                              className="fa fa-eye pointer"
                              onClick={() => {
                                this.setState({
                                  orderDetails: qr.qr_orders,
                                  singleOrder: qr,
                                });
                                this.viewToggle();
                              }}
                            ></i>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              ) : (
                "No Order Placed yet"
              )}
              {/* View Order Modal */}
              <Modal isOpen={this.state.viewOrderModal} size="lg">
                <div className="d-flex p-2">
                  <label>Order Details</label>
                  <i
                    className="fa fa-times text-danger ml-auto pointer"
                    onClick={this.viewToggle}
                  ></i>
                </div>
                <ModalBody>
                  {this.state.orderDetails.length > 0 &&
                    this.state.orderDetails.map((_qr, idx) => {
                      return (
                        <div className="mb-5">
                          <Row>
                            <Col md="4">
                              <div className="preview" key={idx}>
                                <div className="top-text">{_qr.topText}</div>
                                <div
                                  className="p-4 m-0 text-center"
                                  style={{
                                    backgroundColor: _qr.color,
                                  }}
                                >
                                  <QRCode
                                    value={_qr.qrValue}
                                    bgColor={_qr.color}
                                    fgColor="#484E9C"
                                  />
                                </div>
                                <div className="bottom-text">
                                  {_qr.bottomText}
                                </div>
                              </div>
                            </Col>
                            <Col md="8" className="p-0">
                              <Steps current={this.getStep()}>
                                <Step title="Placed" />
                                <Step title="Shipped" />
                                <Step title="Delivered" />
                                <Step title="Completed" />
                              </Steps>
                              <Timeline className="mt-5">
                                <Timeline.Item
                                  color={this.getStep() != 0 ? "green" : "red"}
                                >
                                  Order Created At{" "}
                                  {this.state.singleOrder &&
                                    this.state.singleOrder.created_at &&
                                    moment
                                      .unix(
                                        this.state.singleOrder.created_at
                                          .seconds
                                      )
                                      .format("DD-MM-YYYY")}
                                </Timeline.Item>
                                <Timeline.Item
                                  color={
                                    this.getStep() == 1
                                      ? "red"
                                      : this.getStep() < 1
                                      ? "gray"
                                      : "green"
                                  }
                                >
                                  <p>
                                    Order Shipped On{" "}
                                    {this.state.singleOrder &&
                                      this.state.singleOrder.shipped_at &&
                                      moment
                                        .unix(
                                          this.state.singleOrder.shipped_at
                                            .seconds
                                        )
                                        .format("DD-MM-YYYY")}
                                  </p>
                                  <small>
                                    {this.state.singleOrder &&
                                      this.state.singleOrder
                                        .shipment_details && (
                                        <>
                                          Shipper:{" "}
                                          <strong>
                                            {this.getShipperName(
                                              this.state.singleOrder
                                                .shipment_details.shipper
                                            )}
                                          </strong>
                                          <br />
                                          Tracking ID:{" "}
                                          <strong>
                                            {
                                              this.state.singleOrder
                                                .shipment_details.tracking_id
                                            }
                                          </strong>
                                        </>
                                      )}
                                  </small>
                                </Timeline.Item>
                                <Timeline.Item
                                  color={
                                    this.getStep() == 2
                                      ? "red"
                                      : this.getStep() < 2
                                      ? "gray"
                                      : "green"
                                  }
                                >
                                  <p>
                                    Order Delivered On{" "}
                                    {this.state.singleOrder &&
                                      this.state.singleOrder.delivered_at &&
                                      moment
                                        .unix(
                                          this.state.singleOrder.delivered_at
                                            .seconds
                                        )
                                        .format("DD-MM-YYYY")}
                                  </p>
                                </Timeline.Item>
                                <Timeline.Item
                                  color={this.getStep() < 3 ? "gray" : "green"}
                                >
                                  <p>
                                    Order Completed On{" "}
                                    {this.state.singleOrder &&
                                      this.state.singleOrder.completed_at &&
                                      moment
                                        .unix(
                                          this.state.singleOrder.completed_at
                                            .seconds
                                        )
                                        .format("DD-MM-YYYY")}
                                  </p>
                                </Timeline.Item>
                              </Timeline>
                            </Col>
                          </Row>
                          <Table className="" bordered responsive>
                            <tr>
                              <th>ID</th>
                              <td>{_qr.qrID}</td>
                            </tr>
                            <tr>
                              <th>Memoir</th>
                              <td>{this.getMemoirName(_qr.memoirID)}</td>
                            </tr>
                            <tr>
                              <th>Material</th>
                              <td>{_qr.material}</td>
                            </tr>
                            <tr>
                              <th>Qty</th>
                              <td>{_qr.qty}</td>
                            </tr>
                            <tr>
                              <th>Price</th>
                              <td>{_qr.price}</td>
                            </tr>
                          </Table>
                        </div>
                      );
                    })}
                </ModalBody>
              </Modal>
            </div>
          </div>
          {/* Image Crop Modal */}
          <Modal
            isOpen={
              this.state.profile_image?.length > 0
                ? this.state.profile_image
                : ""
            }
          >
            <ModalBody>
              <h2>Crop Profile image</h2>
              {console.log(
                this.state.profile_image,
                "this.state.profile_image"
              )}
              <div
                style={{
                  position: "relative",
                  top: "0",
                  width: "100%",
                  height: "60vh",
                  paddingLeft: "10%",
                }}
              >
                {/* <Cropper
                  image={this.state.profile_image}
                  crop={this.state.crop}
                  zoom={this.state.zoom}
                  aspect={this.state.aspect}
                  onCropChange={this.onCropChange}
                  onCropComplete={this.onCropComplete}
                  onZoomChange={this.onZoomChange}
                  style={{ width: "100%" }}
                /> */}
                {!!this.state.profile_image && (
                 <ReactCrop
                 crop={crop}
                 onChange={(_, percentCrop) => this.setState({ crop: percentCrop })}
                 onComplete={this.onCropComplete}
                 aspect={aspect}
               >
                    <img
                      ref={this.state.imgRef}
                      alt="Crop me"
                      src={this.state.profile_image}
                      onLoad={this.onImageLoad}
                    />
                  </ReactCrop>
                )}
              </div>
              <div className="text-right mt-3">
                <Button
                  className="mr-2"
                  color="danger"
                  disabled={this.state.profile_loading}
                  onClick={() => {
                    this.setState({
                      imageUpdate: false,
                      profile_image: null,
                    });
                  }}
                >
                  Close
                </Button>
                <Button
                  color="primary"
                  onClick={this.saveImage}
                  disabled={this.state.profile_loading}
                >
                  {this.props.profile_loading ? (
                    <Spinner size="sm" />
                  ) : (
                    "Save Image"
                  )}
                </Button>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    imageLoading: state.auth.imageLoading,
    card_details: state.auth.card_details,
    authUser: state.authUser,
    qr_orders: state.orderQrCode.order_qr_codes,
    memoirs: state.memoir.memoirs,
    shippers: state.orderQrCode.shippers,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateUser: (uid, user, currentPassword, onSuccess) =>
      dispatch(updateUser(uid, user, currentPassword, onSuccess)),
    updatePlanEarnings: (uid, obj) => dispatch(updatePlanEarnings(uid, obj)),
    updateProfileImage: (uid, file, prevFile, func) =>
      dispatch(updateProfileImage(uid, file, prevFile, func)),
    getPackages: () => dispatch(getPackages()),
    getQROrders: (uid) => dispatch(getOrderQrCodes(uid)),
    fetchMemoirs: (uid) => dispatch(getMemoirs(uid)),
    updateUserInfo: (uid, obj) => dispatch(updateUserInfo(uid, obj)),
    fetchShippers: () => dispatch(fetchShipmentDetails()),
    customAlert: (val, message) => dispatch(customAlert(val, message)),
    getCardDetails: (id, onSuccess) => dispatch(getCardDetails(id, onSuccess)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageAccount);
